module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isFetching),
      expression: "isFetching"
    }],
    ref: "scroll-area",
    staticClass: "schedule"
  }, [_c('div', {
    staticClass: "steps"
  }, [(_vm.records.length !== 0) ? _c('el-steps', {
    attrs: {
      "space": 100,
      "direction": "vertical",
      "active": _vm.currentEventIndex,
      "process-status": "finish",
      "finish-status": "wait"
    }
  }, [_vm._l((_vm.records), function(record, index) {
    return [_c('el-step', {
      ref: 'step' + index + 'ref',
      refInFor: true
    }, [_c('a', {
      class: (record['連結'] ? 'step_title_link' : ''),
      attrs: {
        "href": record['連結'],
        "target": "_blank"
      },
      slot: "title"
    }, [_vm._v("\n            " + _vm._s(record['大標題']) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "schedule-fa-icon",
      slot: "icon"
    }, [_c('icon', {
      attrs: {
        "name": record['fa-icon'] || _vm.default_icon
      }
    })], 1), _vm._v(" "), _c('div', {
      slot: "description"
    }, [_vm._v("\n            " + _vm._s(_vm.formatDates(record['開始時間'], record['結束時間']))), _c('br'), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.clipSubtitle(record['副標題']))
      }
    })])])]
  })], 2) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-780cdbcf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Schedule.vue
// module id = 976
// module chunks = 1